module.exports = __webpack_public_path__ + "img/5e8fdeaf-a95f-4566-adac-d84c9605a176.a19e17ec.png";